/* eslint-disable no-undef */
import { gsap } from 'gsap';

const parentClicked = (e) => {
  const { target } = e;

  // make sure you have the li
  const listItem = target.closest('li');

  if (
    target.classList.contains('sub-menu-back--wrapper') ||
    target.closest('.sub-menu-back--wrapper')
  ) {
    return;
  }

  if (
    (target.tagName === 'svg' || target.tagName === 'path') &&
    target.closest('.menu-item-featured-post-link') === null
  ) {
    e.preventDefault();
  }

  if (
    target.tagName === 'A' &&
    ((listItem.classList.contains('menu-item-level-1') && target.closest('.sub-menu--mega-menu')) ||
      listItem.classList.contains('menu-item-level-0'))
  ) {
    e.preventDefault();
  }

  const mobileNav = document.getElementById('mobileNav');
  const children = Array.from(listItem.children);
  children.forEach((child) => {
    if (child.classList.contains('sub-menu-wrapper')) {
      child.classList.add('isActive');
      gsap.to(child, { duration: 0.3, x: '0%', zIndex: 100 });
      mobileNav.classList.add('no-scroll');
      gsap.to(mobileNav, { duration: 0, scrollTo: 0 });
    }
  });
};

const closeSubNav = (e) => {
  const mobileNav = document.getElementById('mobileNav');
  const subNav = e.target.closest('.sub-menu-wrapper');

  subNav.classList.remove('isActive');
  gsap.to(subNav, { duration: 0.3, x: '-100%' });
  mobileNav.classList.remove('no-scroll');
};

document.addEventListener('DOMContentLoaded', () => {
  const mobileNav = document.getElementById('mobileNav');
  const toggle = document.getElementById('primaryNav-toggle');
  const parentNavItems = document.getElementsByClassName('menu-item-has-children');
  const subMenuCloseButtons = document.getElementsByClassName('sub-menu-back');
  let open = false;
  let count = 0;
  const openText = document.getElementById('primaryNav-toggle-openText');
  const closeText = document.getElementById('primaryNav-toggle-closeText');

  if (!toggle) {
    return;
  }

  if (mobileNav === null) {
    return;
  }

  toggle.onclick = () => {
    open = !open;

    toggle.classList.toggle('active');
    document.getElementsByTagName('html')[0].classList.toggle('no-scroll');
    document.getElementsByTagName('html')[0].classList.toggle('mobile-open');

    if (count > 0) {
      toggle.classList.toggle('closed');
    }

    count += 1;

    if (closeText !== null) {
      gsap.to(closeText, { duration: 0, autoAlpha: 1, y: '-100%' });
    }

    if (open) {
      gsap.to(mobileNav, {
        duration: 0.3,
        autoAlpha: 1,
        display: 'block',
        animationTimingFunction: 'ease',
      });
      if (openText !== null && closeText !== null) {
        gsap.to(openText, { duration: 0.3, autoAlpha: 0, y: '100%', display: 'none' });
        gsap.to(closeText, { duration: 0.3, autoAlpha: 1, y: '0%', display: 'block' });
      }
    } else {
      gsap.to(mobileNav, {
        duration: 0.2,
        autoAlpha: 0,
        display: 'none',
        animationTimingFunction: 'ease-out',
      });
      if (openText !== null && closeText !== null) {
        gsap.to(closeText, { duration: 0.3, autoAlpha: 0, y: '-100%', display: 'none' });
        gsap.to(openText, { duration: 0.3, autoAlpha: 1, y: '0%', display: 'block' });
      }
    }
  };

  for (let i = 0; i < parentNavItems.length; i += 1) {
    parentNavItems[i].addEventListener('click', parentClicked);
  }

  for (let j = 0; j < subMenuCloseButtons.length; j += 1) {
    subMenuCloseButtons[j].addEventListener('click', closeSubNav);
  }
});
